<template>
  <v-container fluid>
    <v-row dense>
      <v-col
        class="products"
        v-for="(card, index) in cards"
        v-bind:key="index"
        sm="12"
        md="6"
        cols="auto"
      >
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 12 : 2">
            <v-img
              :src="card.src"
              class="align-center"
              gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,.5)"
              max-height="200px"
            >
              <v-card-title v-text="card.title"></v-card-title>
              <v-card-subtitle v-text="card.sub"></v-card-subtitle>
              <v-card-text v-text="card.text"></v-card-text>
            </v-img>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-bookmark</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-hover>
      </v-col>
      <v-col v-if="inprogress" cols="12">
        <v-row justify="center">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2">
              <v-card-title>**STILL IN PROGRESS**</v-card-title>
            </v-card>
          </v-hover>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    inprogress: false,
    cards: [
      {
        title: "Moisturizing Lotion",
        src: require("../assets/lotion.jpg"),
        sub: "2oz - $5.50",
        text:
          "A light, non-greasy lotion made with shea butter and jojoba oil. We are able to incorporate any combination of oils you desire from our available scents."
      },
      {
        title: "Eventide Pillow Spray",
        src: require("../assets/pillow_spray.jpg"),
        sub: "0.33oz - $5.50",
        text:
          "A deep calming spray formulated to help you fall asleep faster using a blend which includes: Lavender, Vetiver, Patchouli, and more."
      }
    ]
  })
};
</script>
